import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog } from "@intelligems/ig-theme";
import { Experience } from "@src/store/slices/experiences/types";
import { isDialogOpen, setDialog } from "@src/store/slices/global";

interface AdminOverrideStartExpDialogProps {
  experience: Experience;
  onExpButtonClick: (experiment: Experience) => void;
}
export const AdminOverrideStartExpDialog = ({
  onExpButtonClick,
  experience,
}: AdminOverrideStartExpDialogProps) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("adminOverrideStartExp"));

  const handleClose = () => {
    dispatch(setDialog({ dialog: "adminOverrideStartExp", open: false }));
  };

  return (
    <IgDialog
      dialogTitleWidth={"365px"}
      title={"This store has NOT approved billing."}
      subtitle={"Are you sure you want to start their experiment?"}
      handleClose={handleClose}
      showDialog={isOpen}
      handleYesClick={() => {
        onExpButtonClick(experience);
        handleClose();
      }}
      yesButtonText={"Yes"}
      shouldNotClose={true}
      dialogHeight={null}
    />
  );
};
